import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SetupPage } from "@/features/setup/SetupPage";

const search = z.object({
  state: z.enum(["loading", "empty", "error"]).optional(),
});

/** Public setup wizard step (workspace, type, kit, country, team, done). Outside the _app layout. */
export const Route = createFileRoute("/setup/$step")({
  validateSearch: search,
  component: SetupRoute,
});

function SetupRoute() {
  const { step } = Route.useParams();
  const { state } = Route.useSearch();
  return <SetupPage step={step} state={state} />;
}
